import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth4patchPatchScreenTruthAppsAppChromeRequirementsIdResponseSchema = jsonObject
export type tcpscreentruth4patchPatchScreenTruthAppsAppChromeRequirementsIdResponse = z.infer<typeof tcpscreentruth4patchPatchScreenTruthAppsAppChromeRequirementsIdResponseSchema>
